import * as React from 'react'
import {ReactNode} from 'react'
import {
    BlockSpacer,
    currentMedia,
    GridContainer,
    GridItem
} from '../../../../../styledComponents/ResponsiveConvenience'
import {APPLY_CATEGORY, CONTRACTOR_REQUEST} from '../../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../../common/util/Natutil'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {DisplayItemLabelDiv} from '../../../../../styledComponents/DisplayItem'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {Colors, FontWeights} from '../../../../../styledComponents/Constants'
import {FileInformation} from '../../../../../components/applications/ResidentAttachmentFileArea'
import {
    getFormattedAddress,
    getFormattedDate
} from '../../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {Nullable} from '../../../../../app/TypeHelpers';
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents';

interface Props {
    applicantFamilyName: string
    applicantFirstName: string
    windowFilmAttachDate: string
    contractorRequest: string
    contractorName: Nullable<string>
    contractorZipCode: Nullable<string>
    contractorPrefecture: Nullable<string>
    contractorAddress2: Nullable<string>
    contractorAddress3: Nullable<string>
    contractorBuildingRoomNumber: Nullable<string>
    contractorPhoneNumber: Nullable<string>
    contractorRep: Nullable<string>
    applyToAttachment: FileInformation[]
    applyFlag?: boolean
}

const NatResidentWindowFilmAttachConfirm = ({applyFlag = true, ...otherProps}: Props) => {
    const {
        applicantFamilyName,
        applicantFirstName,
        windowFilmAttachDate,
        contractorRequest,
        contractorName,
        contractorZipCode,
        contractorPrefecture,
        contractorAddress2,
        contractorAddress3,
        contractorBuildingRoomNumber,
        contractorPhoneNumber,
        contractorRep,
        applyToAttachment
    } = otherProps

    const applyCategoryLabel = APPLY_CATEGORY.WINDOW_FILM_ATTACH_APPLY.label
    const applicantRoom = NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
        NatResidentLoginInfoSessionStorageHelper
            .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
        convertToRoomNumberForResident(
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
        )
    const windowFilmAttachDateLabel = (windowFilmAttachDate) ?
        getFormattedDate(windowFilmAttachDate) : ''

    const contractorRequestLabel = (contractorRequest) ?
        CONTRACTOR_REQUEST.codeToEnumConstants(contractorRequest).label : ''
    const contractorZipCodeLabel = (contractorZipCode) ? contractorZipCode : ''
    const contractorPrefectureLabel = (contractorPrefecture) ? contractorPrefecture : ''
    const contractorAddress2Label = (contractorAddress2) ? contractorAddress2 : ''
    const contractorAddress3Label = (contractorAddress3) ? contractorAddress3 : ''
    const contractorBuildingRoomNumberLabel = (contractorBuildingRoomNumber) ? contractorBuildingRoomNumber : ''

    const contractorInfo = (): ReactNode => {
        const items = []
        items.push(`業者名：${contractorName}`)
        items.push(`住所：${getFormattedAddress(
            contractorZipCodeLabel,
            contractorPrefectureLabel,
            contractorAddress2Label,
            contractorAddress3Label,
            contractorBuildingRoomNumberLabel)}`
        )
        items.push(`電話番号：${contractorPhoneNumber}`)
        items.push(`担当者：${contractorRep}`)

        return <>
            <NatResidentApplicationDetailConfirmItem
                title={'窓ガラスフィルム貼付施工者'}
                items={items}
            />
        </>
    }

    return (<>
        {applyFlag === true &&
            <>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請区分'}
                    items={[applyCategoryLabel]}
                />
                <BlockSpacer height={'5px'}/>
                <NatResidentApplicationDetailConfirmItem
                    title={'申請者'}
                    items={[applicantRoom, `${applicantFamilyName} ${applicantFirstName}`]}
                />
            </>
        }
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'窓ガラスフィルムの貼付日'}
            items={[windowFilmAttachDateLabel]}
        />
        <BlockSpacer height={'5px'}/>
        <NatResidentApplicationDetailConfirmItem
            title={'施工依頼'}
            items={[contractorRequestLabel]}
        />
        {(contractorRequest === CONTRACTOR_REQUEST.REQUEST.value) ?
            <>
                <BlockSpacer height={'5px'}/>
                {contractorInfo()}
            </> : null
        }
        <BlockSpacer height={'5px'}/>
        <ItemDiv>
            <GridContainer>
                <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>添付資料</Box></DisplayItemLabelDiv>
                </GridItem>
                <GridItem over={9}>
                    {(applyToAttachment && applyToAttachment.map((attachmentFile, index) => (
                        <TextContents key={index}>
                            {attachmentFile.fileName}
                        </TextContents>
                    )))}
                </GridItem>
            </GridContainer>
        </ItemDiv>
        {applyFlag === false &&
            <>
                <BlockSpacer height={'5px'}/>
                <ItemDiv>
                    <GridContainer alignItems={'flex-start'}>
                        <GridItem over={3}><DisplayItemLabelDiv><Box mr={'5px'}>承認条件</Box></DisplayItemLabelDiv>
                        </GridItem>
                        <GridItem over={9}>
                            <RowFlexContainer>
                                <Box whiteSpace={'pre-wrap'}>
                                    一 フィルムの貼付内容は、窓ガラスフィルム貼付申請書記載のとおりとすること<br/>
                                    二 フィルム貼付等に要する費用は、すべて申請者の負担とすること<br/>
                                    三 フィルム貼付等のために共用部分を毀損し、または他の組合員に迷惑をかけたときは、申請者の責任において復旧または補償を行うこと<br/>
                                    四 管理組合は、前各号の規定に反すると認めたときは、承認を取り消し、必要な処置を講ずる場合があること
                                </Box>
                            </RowFlexContainer>
                        </GridItem>
                    </GridContainer>
                </ItemDiv>
            </>
        }
    </>)
}

NatResidentWindowFilmAttachConfirm.displayName = 'NatResidentWindowFilmAttachConfirm'
export default NatResidentWindowFilmAttachConfirm

const ItemDiv = styled.div`
  background-color: ${Colors.Surface};
 ${currentMedia.lessThan('sp')`
    margin: 0px -15px;
  `}
  padding: 20px 15px 20px 15px;
`
const TextContents = styled.div`
  font-weight: ${FontWeights.Bold};
  overflow-wrap: anywhere;
`